var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 30,
    viewBox: "0 0 21 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8031 28.5996C20.8031 29.3717 20.175 29.9999 19.4029 29.9999H6.46491V14.8215H12.0938C12.8658 14.8215 13.494 15.4497 13.494 16.2217V21.5706H19.4029C20.175 21.5706 20.8031 22.1987 20.8031 22.9708V28.5996Z",
    fill: "#FC9502"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8031 28.5996C20.8031 29.3717 20.175 29.9998 19.4029 29.9998H13.494V21.5706H19.4029C20.175 21.5706 20.8031 22.1987 20.8031 22.9708V28.5996Z",
    fill: "#FCE202"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41418 8H1.172C0.525825 8 0.00012207 8.5257 0.00012207 9.17188V28.8281C0.00012207 29.4743 0.525825 30 1.172 30H6.58606V11.6484V9.17188C6.58606 8.5257 6.06036 8 5.41418 8Z",
    fill: "#C13C0B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2650_30363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.64709 0.956299V6.25968L9.60581 3.608L2.64709 0.956299Z",
    fill: "#FF4343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.45129 0.648438H2.87262V8.99996H2.45129V0.648438Z",
    fill: "#707E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.87262 0.648438H2.45129V8.99994H2.87262V6.1737V1.04228V0.648438Z",
    fill: "#515A66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.97299 0.125988C2.89246 0.0480417 2.78284 0 2.66191 0C2.45526 0 2.28143 0.140137 2.23002 0.330518C2.21995 0.367804 2.21448 0.406976 2.21448 0.447437C2.21448 0.694552 2.4148 0.894874 2.66191 0.894874C2.69605 0.894874 2.72922 0.890925 2.76117 0.883682C2.9605 0.838518 3.10937 0.66042 3.10937 0.447417C3.10937 0.321251 3.05704 0.207328 2.97299 0.125988Z",
    fill: "#515A66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2650_30363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(1.41003)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.7ebde04028c3a1c1bf460cc1ed6cbb52.svg";
export { ForwardRef as ReactComponent };